import { defineComponent, mergeModels, useCssVars, computed, ref, useModel, onMounted, onUnmounted, createElementBlock, openBlock, normalizeClass, createCommentVNode, createElementVNode, createVNode, unref, mergeProps, renderSlot } from "vue";
import { WButton } from "../WButton/index.js";
import { useViewport } from "../../composables/index.js";
import "../WIcon/WIconStd/index.js";
import "../WIcon/WIconExt/index.js";
import { iconToProp } from "../WIcon/index.js";
import { _export_sfc } from "../WAccordion/index.js";
import "../WLottie/index.js";
import "vue-router";
import './index.css';const _hoisted_1 = {
  key: 0,
  class: "w-lane-scroller__left-button"
};
const _hoisted_2 = {
  key: 1,
  class: "w-lane-scroller__right-button"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WLaneScroller",
  props: /* @__PURE__ */ mergeModels({
    scrollBarAttrs: {},
    showScrollControls: { type: Boolean },
    compensationLeft: {},
    compensationRight: {}
  }, {
    "scrollRef": {
      default: null
    },
    "scrollRefModifiers": {}
  }),
  emits: ["update:scrollRef"],
  setup(__props) {
    useCssVars((_ctx) => ({
      "4af375de": compensationPaddingLeftCss.value,
      "8b78af5c": compensationPaddingRightCss.value,
      "862c0d54": compensationLeftCss.value,
      "24567cad": compensationRightCss.value,
      "274178c3": compensationWidthCss.value
    }));
    const props = __props;
    const { breakpoint } = useViewport();
    const containerEl = ref(null);
    const scrollRef = useModel(__props, "scrollRef");
    function setRef(ref2) {
      scrollRef.value = ref2;
      containerEl.value = ref2;
    }
    const abortController = new AbortController();
    const isScrollStart = ref(true);
    const isScrollEnd = ref(false);
    const compensationLeftCssVar = computed(() => {
      const compensationLeft = props.compensationLeft;
      if (!compensationLeft) return "--sp-none";
      if (compensationLeft.startsWith("--")) {
        return compensationLeft;
      }
      return `--sp-${compensationLeft}`;
    });
    const compensationRightCssVar = computed(() => {
      const compensationRight = props.compensationRight;
      if (!compensationRight) return "--sp-none";
      if (compensationRight.startsWith("--")) {
        return compensationRight;
      }
      return `--sp-${compensationRight}`;
    });
    const compensationLeftCss = computed(
      () => `calc(-1 * var(${compensationLeftCssVar.value}, 0px))`
    );
    const compensationRightCss = computed(
      () => `calc(-1 * var(${compensationRightCssVar.value}, 0px))`
    );
    const compensationWidthCss = computed(
      () => `calc(100% + var(${compensationLeftCssVar.value}, 0) + var(${compensationRightCssVar.value}, 0))`
    );
    const compensationPaddingLeftCss = computed(
      () => `var(${compensationLeftCssVar.value}, 0)`
    );
    const compensationPaddingRightCss = computed(
      () => `var(${compensationRightCssVar.value}, 0)`
    );
    function scrollLeft() {
      if (!containerEl.value) {
        return;
      }
      containerEl.value.scrollLeft -= containerEl.value.offsetWidth;
    }
    function scrollRight() {
      if (!containerEl.value) {
        return;
      }
      containerEl.value.scrollLeft += containerEl.value.offsetWidth;
    }
    function updateScrollState() {
      if (!containerEl.value) {
        return;
      }
      const el = containerEl.value;
      if (el.scrollWidth <= el.clientWidth) {
        isScrollStart.value = true;
        isScrollEnd.value = true;
        return;
      }
      isScrollStart.value = el.scrollLeft === 0;
      isScrollEnd.value = el.scrollWidth - el.offsetWidth - el.scrollLeft < 2 || el.scrollWidth === el.offsetWidth;
    }
    const resizeObserver = new ResizeObserver(() => updateScrollState());
    onMounted(() => {
      if (containerEl.value) {
        resizeObserver.observe(containerEl.value);
        containerEl.value.addEventListener("scroll", updateScrollState, {
          signal: abortController.signal
        });
      }
    });
    onUnmounted(() => {
      abortController.abort();
      resizeObserver.disconnect();
    });
    const classes = computed(() => [`--${breakpoint.value}`]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["w-lane-scroller", classes.value])
      }, [
        _ctx.showScrollControls && !isScrollStart.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
          createVNode(unref(WButton), {
            "left-icon": unref(iconToProp)("outline-chevron-left"),
            set: "neutral",
            variant: "secondary",
            compact: "",
            "data-row-span": "",
            onClick: scrollLeft
          }, null, 8, ["left-icon"])
        ])) : createCommentVNode("", true),
        _ctx.showScrollControls && !isScrollEnd.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createVNode(unref(WButton), {
            "left-icon": unref(iconToProp)("outline-chevron-right"),
            set: "neutral",
            variant: "secondary",
            compact: "",
            "data-row-span": "",
            onClick: scrollRight
          }, null, 8, ["left-icon"])
        ])) : createCommentVNode("", true),
        createElementVNode("div", mergeProps({
          ref: (elm) => setRef(elm),
          class: "w-lane-scroller__bar"
        }, _ctx.scrollBarAttrs), [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 16)
      ], 2);
    };
  }
});
const WLaneScroller = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d1d417e8"]]);
export {
  WLaneScroller
};
